<template>
    <div class="additional-services">
        <a v-if="!glb.rentals" class="flex middle" @click="toggle"><span>{{molang('dpp.propertyMortgage.additionalSerices')}}</span></a>
        <div id="cmasw"></div>
    </div>
</template>

<script src="./additional-services-new.js"></script>

<!-- <style lang="scss">
    @use "./additional-services.scss" as *;
</style> -->
